import { Link } from 'react-router-dom';
import styles from './vip-purchase.module.css';
import { StarFilled, RocketFilled } from '@ant-design/icons';

const VipPurchaseSection = ({ tier, variant = "compact" }) => {

    if (variant === "full") {
        return (
            <div className={styles.container}>
                <div className={styles.fullAd}>
                    <div className={styles.adContent}>
                        <div className="d-flex align-items-center gap-2 mb-3">
                            <StarFilled style={{ color: '#ffcc00', fontSize: '24px' }} />
                            <span style={{ fontWeight: 700, letterSpacing: '2px' }}>VIP EXPERIENCE</span>
                        </div>
                        <h2>Elevate Your Status. Unlock the Best.</h2>
                        <p>Get exclusive access to higher multipliers, instant discounts, and priority support. Join the elite tier of earners today.</p>
                        <Link to={"/vip-tiers"}>
                            <button className={`${styles.ctaButton} ${styles.adButton}`}>
                                Explore VIP Perks
                            </button>
                        </Link>
                    </div>
                    <div className={styles.adDecor}></div>
                    <RocketFilled style={{ fontSize: '180px', color: 'rgba(255,255,255,0.15)', position: 'absolute', right: '10%' }} />
                </div>
            </div>
        );
    }

    // COMPACT VERSION (Functional with Details)
    return (
        <div className={styles.container}>
            <div className={styles.compactCard}>
                {/* Tier Name Badge */}
                <div
                    className={styles.tierBadge}
                    style={{
                        color: tier.badgeColor,
                        backgroundColor: `color-mix(in srgb, ${tier.badgeColor} 12%, transparent)`,
                        borderColor: tier.badgeColor
                    }}
                >
                    {tier.name} VIP
                </div>

                {/* Price Section */}
                <div className={styles.priceValue}>
                    ₹{tier.paidPriceInr}
                    <span>/{tier.paidValidityDays}D</span>
                </div>

                {/* Mini Stats Grid */}
                <div className={styles.statsRow}>
                    <div className={styles.miniStat}>
                        <span className={styles.miniValue}>{tier.discountPercent}%</span>
                        <span className={styles.miniLabel}>OFF</span>
                    </div>
                    <div className={styles.miniStat}>
                        <span className={styles.miniValue}>{tier.multiplier}x</span>
                        <span className={styles.miniLabel}>Bonus</span>
                    </div>
                </div>

                <button className={styles.buyButton}>
                    GET VIP
                </button>

                <div className="mt-2" style={{ fontSize: '10px', opacity: 0.5, fontWeight: 600 }}>
                    INSTANT ACCESS
                </div>
            </div>
        </div>
    );
};

export default VipPurchaseSection